import actions from 'actions/products'
import { createFormViewContainer } from 'factories/FormView'
import { createChildItemsDispatchToProps, createDocumentsDispatchToProps } from 'helpers/formViews'
import documentActions from 'actions/documents'
import supplierActions from 'actions/suppliers'
import productCategoryActions from 'actions/productCategories'
import unitsOfMeasureActions from 'actions/unitsOfMeasure'
import customerDetailActions from 'actions/products/customerDetails'
import productAlternateActions from 'actions/products/productAlternates'
import supplierDetailActions from 'actions/products/supplierDetails'
import Component from 'components/Products/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getSuppliers: (params) =>
      dispatch(
        supplierActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
    getProductCategories: (params) =>
      dispatch(productCategoryActions.getOptions({ ...params, active: 'All', pageIndex: 0 })),
    getUnitsOfMeasure: (params) => dispatch(unitsOfMeasureActions.getOptions(params)),
    findByBarcode: (params) => dispatch(actions.findByBarcode(params)),
    migrate: (params) => dispatch(actions.migrate(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
    ...createChildItemsDispatchToProps(dispatch, 'CustomerDetail', customerDetailActions),
    ...createChildItemsDispatchToProps(dispatch, 'ProductAlternate', productAlternateActions),
    ...createChildItemsDispatchToProps(dispatch, 'SupplierDetail', supplierDetailActions),
  }),
})(Component)
